module.exports = __webpack_public_path__ + "img/reading.d5b3b799.svg";